export class ForgotPasswordModel {
  public UserName: string = '';
}